import NavigationBar from "../navigationBar/NavigationBar";

export default function Dashboard() {
  return (
    <div>
      <NavigationBar />
    </div>
  );
}
